import React from "react";
import TextEditor from "app/Components/Fields/TextEditor";

interface DescriptionProps {
  description: string;
  handleChange: (value: string) => void;
  placeholder?: string;
}

function Description({
  description,
  handleChange,
  placeholder = "Game Description",
}: DescriptionProps) {
  return (
    <TextEditor
      text={description}
      handleChange={handleChange}
      placeholder={placeholder}
    />
  );
}

export default Description;
